export const getTabId = () => {
	if (!window.name) {
		window.name = `tab-${Date.now()}-${Math.random().toString(36).substr(2, 9)}`;
	}
	return window.name;
};

export const setTabSpecificData = (key: string, value: string) => {
	const tabId = getTabId();
	sessionStorage.setItem(`${key}-${tabId}`, value);
};

export const getTabSpecificData = (key: string): string | null => {
	const tabId = getTabId();
	return sessionStorage.getItem(`${key}-${tabId}`);
};

export const clearTabSpecificData = (key: string) => {
	const tabId = getTabId();
	sessionStorage.removeItem(`${key}-${tabId}`);
};
